import React from 'react';
import { VIEW, UPDATE, DELETE } from '../../assets/Constants/actionsTypes';
import { Grid, GridColumn as Column, GridNoRecords } from '@progress/kendo-react-grid';
import { DropDownButton, DropDownButtonItem } from '@progress/kendo-react-buttons';
import { useTranslation } from 'react-i18next';

const PopGroupsGrid = (props) => {
    // * we call the hook to make translations
    const { t } = useTranslation('common');

    return (
        <>
            <Grid style={{ height: 'calc(70vh)' }} data={[...props.data]}>
                {/* this is the message when there are no records */}
                <GridNoRecords>{t('grids.no_records')}</GridNoRecords>
                {/* columns of the grid */}
                <Column field="name" title={t('popGroups.grid_column_name')} />
                <Column field="referencePopMatrixCode" title={t('popGroups.grid_column_refPopulation')} />
                <Column field="ecTotal" title={t('popGroups.grid_column_elCriteria')} />
                {/* action column */}
                <Column
                    title={t('grids.action_col')}
                    width="100px"
                    field="actions"
                    cell={gridProps => (
                        <td className="text-center p-0">
                            <DropDownButton className="grid-drop-btn" text="..." onItemClick={(e) => { props.onActionClick(e.item, gridProps.dataItem); }}>
                                <DropDownButtonItem text={t('grids.view_btn')} value={VIEW} />
                                <DropDownButtonItem text={t('grids.update_btn')} value={UPDATE} />
                                <DropDownButtonItem text={t('grids.delete_btn')} value={DELETE} />
                            </DropDownButton>
                        </td>
                    )}
                />
            </Grid>
        </>
    )
}

export default PopGroupsGrid